// Agregar al carrito sin perder la venta por fallos pasajeros de la API.

// Fallo pasajero: sin respuesta (red), demasiadas peticiones (429) o error del servidor (5xx).
export const isTransientError = (error) => {
    if (!error || !error.response) return true;
    const status = error.response.status;
    return status === 429 || status >= 500;
};

// Espera antes de reintentar: la que pida el servidor (Retry-After, hasta 3 s) o 0,7 s y luego 1,5 s.
export const retryDelay = (error, attempt) => {
    const headers = (error && error.response && error.response.headers) || {};
    const seconds = parseFloat(headers['retry-after']);
    if (!Number.isNaN(seconds)) return Math.min(seconds * 1000, 3000);
    return attempt === 1 ? 700 : 1500;
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Repite la petición hasta 2 veces si el fallo es pasajero. Repetir no duplica el producto: si ya quedó
// guardado, el servidor responde que ya está en el carrito.
export const withRetry = (request, retries = 2, wait = sleep) => {
    const attempt = (n) =>
        request().catch((error) => {
            if (n > retries || !isTransientError(error)) throw error;
            return wait(retryDelay(error, n)).then(() => attempt(n + 1));
        });
    return attempt(1);
};

// Resultado de cart/add, que responde 200 también cuando no agrega: 'added', 'already' (ya estaba en el
// carrito) o { error } con el mensaje para el cliente.
export const cartAddOutcome = (response) => {
    const data = (response && response.data) || {};
    if (data.errors) return { error: 'No pudimos agregar el producto, intenta de nuevo.' };
    if (data.status === 0) {
        if (data.code === 'already_added') return 'already';
        if (data.code === 'out_of_stock') return { error: 'No hay unidades suficientes de este producto.' };
        if (data.code === 'product_not_found') return { error: 'Este producto ya no está disponible.' };
    }
    // Sin "code" (backend anterior) se mantiene lo de siempre: se toma como agregado.
    return 'added';
};

// Sesión vencida o revocada: el token guardado ya no sirve.
export const isSessionExpired = (error) => !!(error && error.response && error.response.status === 401);

// Mensaje cuando la petición falla del todo, después de los reintentos.
export const cartAddErrorMessage = (error) => {
    if (error && !error.response) return 'No hay conexión. Revisa tu internet e intenta de nuevo.';
    return 'No pudimos agregar el producto, intenta de nuevo.';
};
